export const COMMON_THUMBNAIL_URL =
  "https://bwc-sports-storage.s3.us-east-1.amazonaws.com/videos/common/bwcSports_video_thumbnail.png";
export const SCHOOL_PROGRAM_PDF =
  "https://indd.adobe.com/view/3470bf83-8503-4c80-a426-08b856f107ca";

export const MEDIA_LINKS = {
  FIELD_DAYS: {
    VIDEO:
      "https://bwc-sports-frontend.s3.us-east-1.amazonaws.com/Field-Days-2024.mp4",
    ADDITIONAL_SERVICES:
      "https://indd.adobe.com/view/be0eaf55-1505-4c0b-aaa6-d6c051053ac4",
    CARNIVAL_PRICE:
      "http://bwc-sports-frontend.s3.us-east-1.amazonaws.com/new+carnival+sheet++%282%29_compressed.pdf",
  },
  SCHOOL_PROGRAMS: {
    VIDEO_01:
      "https://bwc-sports-frontend.s3.us-east-1.amazonaws.com/Recess-Programs-2024.mp4",
    VIDEO_02:
      "https://bwc-sports-frontend.s3.us-east-1.amazonaws.com/Sports-and-Rec-Days.mp4",
    VIDEO_03:
      "https://bwc-sports-frontend.s3.us-east-1.amazonaws.com/Fun-Days-2024.mp4",
  },
  SUMMER_CAMP: {
    VIDEO_01:
      "https://bwc-sports-storage.s3.us-east-1.amazonaws.com/videos/summer_camp/new-1-video-baseball.mp4",
    VIDEO_02:
      "https://bwc-sports-storage.s3.us-east-1.amazonaws.com/videos/summer_camp/yellow-video.mp4",
  },
  FUND_RAISING: {
    VIDEO_01:
      "https://bwc-sports-frontend.s3.us-east-1.amazonaws.com/Swish-and-Wish-2024.mp4",
  },
};
